import { jsxs as u, jsx as t } from "react/jsx-runtime";
import N from "clsx";
import { forwardRef as L, useRef as d, useEffect as M } from "react";
const S = (n) => N(n), E = () => `${Math.random().toString(36)}00000000000000000`.slice(2, 7), w = (n) => (a) => {
  n.forEach((r) => {
    typeof r == "function" ? r(a) : r != null && (r.current = a);
  });
}, e = "dds-checkbox-v0173", R = L(
  ({
    ariaDescribedby: n,
    defaultChecked: a = !1,
    className: r = "",
    disabled: s = !1,
    hiddenLabel: l = !1,
    id: m,
    indeterminate: o = !1,
    inputProps: _ = {},
    invalid: i = !1,
    label: f = "Default label",
    labelNode: p,
    name: $,
    onChange: g,
    value: v,
    ...x
  }, b) => {
    const k = {
      [e]: !0,
      [r]: r.length > 0,
      [`${e}--disabled`]: s,
      [`${e}--invalid`]: i
    }, c = d(null), { current: y } = d(`${e}-${E()}`), h = m || y;
    return M(() => {
      a && c.current ? (c.current.checked = !0, c.current.indeterminate = !1) : o && c.current ? (c.current.checked = !1, c.current.indeterminate = !0) : c.current && (c.current.checked = !1, c.current.indeterminate = !1);
    }, [o, a]), /* @__PURE__ */ u("label", { htmlFor: h, className: S(k), ...x, children: [
      /* @__PURE__ */ t(
        "input",
        {
          "aria-describedby": n,
          "aria-invalid": i ? "true" : "false",
          id: h,
          type: "checkbox",
          className: `${e}__input`,
          defaultChecked: a,
          disabled: s,
          name: $,
          value: v,
          "aria-label": l ? f : void 0,
          ref: w([c, b]),
          ..._,
          onChange: s ? void 0 : g
        }
      ),
      /* @__PURE__ */ u("div", { className: `${e}__control`, children: [
        /* @__PURE__ */ t(
          "svg",
          {
            className: `${e}__glyph ${e}__glyph--check`,
            viewBox: "0 0 8 8",
            children: /* @__PURE__ */ t("path", { d: "M6.779,0.297c0.204-0.306,0.618-0.389,0.924-0.185c0.276,0.184,0.37,0.537,0.238,0.83L7.888,1.037L3.444,7.703 c-0.212,0.318-0.641,0.388-0.94,0.174L2.417,7.805L0.195,5.583c-0.26-0.26-0.26-0.682,0-0.943c0.231-0.231,0.591-0.257,0.85-0.077 L1.138,4.64l1.646,1.646L6.779,0.297z" })
          }
        ),
        /* @__PURE__ */ t(
          "svg",
          {
            className: `${e}__glyph ${e}__glyph--indeterminate`,
            viewBox: "0 0 8 8",
            children: /* @__PURE__ */ t("path", { d: "M0,4c0-0.368,0.298-0.667,0.667-0.667h6.667C7.702,3.333,8,3.632,8,4S7.702,4.667,7.333,4.667H0.667 C0.298,4.667,0,4.368,0,4z" })
          }
        ),
        /* @__PURE__ */ t("div", { className: `${e}__hidden-touch-target` })
      ] }),
      !l && (p ?? /* @__PURE__ */ t("span", { className: `${e}__label`, children: f }))
    ] });
  }
);
export {
  R as Checkbox
};
//# sourceMappingURL=index.js.map
